import { Info } from 'lucide-react'
import React from 'react'
import useInfoPanelStore from '../context/InfoPanelStore'

type InfoButtonProps = {
    title: string
    text: string
    ariaLabel?: string
    className?: string
}

const InfoButton: React.FC<InfoButtonProps> = ({
    title, text, ariaLabel, className = 'w-5 h-5'
}) => {
    const { showInfo } = useInfoPanelStore()

    return (
        <button
            type="button"
            aria-label={ariaLabel || title || 'More information'}
            onClick={() => showInfo(title, text)}
            className="flex w-fit h-fit rounded-lg leading-none text-kibuBlue font-headline text-sm"
        >
            <Info className={`${className} text-kibuBlue cursor-pointer`} />
        </button>
    )
}

export default InfoButton
